export class Telefone {
  id: bigint;
  numero: string;
  // pessoa: Pessoa;
}
